module.exports = __webpack_public_path__ + "img/img_value.693d2afc.png";